import state from "@/store/modules/planning/state";
import getters from "@/store/modules/planning/getters";
import actions from "@/store/modules/planning/actions";
import mutations from "@/store/modules/planning/mutations";

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}
